import {Component, Input, OnInit, AfterViewInit, HostListener} from '@angular/core';
import {Router,ActivatedRoute} from '@angular/router';
import {Question} from '../question/question';
import {MessageService} from '../message.service';
import {ApiService} from '../api.service';
import {CommonService} from '../common.service';
import {Survey} from './survey';
import {appRenameFixed} from '../appRenameFixed';

declare var $: any;

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css',]
})
export class SurveyComponent implements OnInit, AfterViewInit {
  @Input() surveyMetaId: string;
  @Input() learningPathId: string;
  @Input() learningTourId: string;
  appRename: appRenameFixed = new appRenameFixed();

  @HostListener('window:popstate', ['$event']) onPopState() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  step: string;
  selectedQuestion: Question;

  learningTour: any;
  survey: any;
  tickTimeData: any;
  preSurveyID: number;

  totalNumber: number;
  remindTime: number;
  totalTime: number;
  intervalId: any;

  sceneBtnDetailShow: boolean;

  currentNumber: number;

  finishedNumber: number;

  sceneChangeNumber: number;

  sceneStartAndEnd: any;
  sceneNames: any;
  sceneDescription: any;

  restart: boolean;

  report: any;

  graduation: any;

  preSceneOne: string;
  preSceneTwo: string;
  postSceneOne: string;
  postSceneTwo: string;

  sceneText: string;
  sceneBtnDetailText: string;
  sceneBtnDetail: string;

  popup: boolean;
  isOpenClass: number = 0;
  clickable: boolean;
  projectId: string;
  isOnlyLearningPathCannotBack: boolean = false;

  userType: string;
  abilityBack: boolean;
  tourSingleReport: any;
  item1: any;
  item2: any;
  item3: any;
  item4: any;
  item5: any;
  item6: any;
  item7: any;
  assetsRoute: string = '../../assets';
  isHarmonyOS = false; //是否鸿蒙系统


  constructor(private router: Router,
              private apiService: ApiService,
              private messageService: MessageService,
              private commonService: CommonService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
    localStorage.setItem('learningPathMetaId','0');
    $('#learningPathMetaIdContainer').val(0);
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.restart = false;
    this.clickable = true;
    this.tourSingleReport = null;
    this.userType = window.sessionStorage.getItem('userType');
    this.surveyInit();
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.isOnlyLearningPathCannotBack = window.location.href.indexOf('onlyLearningPathCannotBack') !== -1;

    this.projectId = localStorage.getItem("projectId")

    this.route.queryParams.subscribe(params => {
      if(params.isCamp && params.isCamp === 'true'){
        this.apiService.learingTime({learningPathMetaId:Number(localStorage.getItem("learningPathMetaId")),module:"领导力DNA测验",type:0,btnName:'领导力DNA',userId:localStorage.getItem('userId')}).subscribe(result=>{
        });
      }
    });

    // console.log(this.userType);

    /*this.sceneBtnDetailShow = false;
    this.getMockSurvery();
    this.step = "begin";

    if(this.survey.type == 2) {
        this.sceneChangeNumber = 3;
    }else if(this.survey.type == 3){
        $("#scene_text p").text("在过去的几个月中，你的一位下属一直苦于达不到绩效目标，为了帮助他提升表现，你决定采取以下行动，请对每项行动的有效程度做出评估。");
        this.sceneChangeNumber = 3;
    }
    this.preSceneOne = "为完成一个新项目，你的下属将第一次独自带领一个跨部门项目团队，他对此不是很有经验和信心，为帮助他更好地胜任这个角色，你决定采取以下行动，请对每项行动的有效程度做出评估。";
    this.preSceneTwo = "最近一个月，你的一位下属在工作中表现不似以往那样积极主动，业绩也呈现下滑趋势，为了帮助他提升工作表现，你决定采取以下行动，请对每项行动的有效程度做出评估。";
    this.postSceneOne = "在过去的几个月中，你的一位下属一直苦于达不到绩效目标，为了帮助他提升表现，你决定采取以下行动，请对每项行动的有效程度做出评估。";
    this.postSceneTwo = "你收到来自另一个平行团队的抱怨邮件，最近你的一位下属在与他们合作时，没有积极响应对方的合作需求，提交给对方的报告也经常出现质量问题，甚至已经影响到了项目的整体进度，为改善这一状况，你决定采取以下行动，请对每项行动的有效程度做出评估。";


    this.popup = false;*/

  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: 'white'
    });
  }

  surveyInit() {
    let that = this;
    // console.log(that.userType);
    if (this.learningTourId == 'not') {
      this.apiService.getOrCreateSurvey(this.surveyMetaId, this.learningPathId, this.learningTourId).subscribe(survey => {
        this.survey = survey;
        this.surveyInitCallBack();
      });
    } else if (this.learningPathId == 'not') {
      this.apiService.ajax({
        'type': 'post',
        'url': '/sr/coursedna/' + this.learningTourId + '/showSurvey/' + this.surveyMetaId
      }).subscribe(survey => {
        this.survey = survey[0];
        if(localStorage.getItem("source_env") == "LMS_SCORM"){
          this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',this.survey.progress,"data");
          this.commonService.sendDataMessage('type','LMS_LEARN_COMPLETED',Number(this.survey.progress) === 100.00 ,"data");
        }
        // console.log(this.survey);
        this.surveyInitCallBack();
        this.item1 = null;
        this.item2 = null;
        this.item3 = null;
        this.item4 = null;
        this.item5 = null;
        this.item6 = null;
        this.item7 = null;
        if (this.survey.status != 0) {
          this.apiService.getDNAReport('' + this.survey.id + '').subscribe(result => {
            this.learningTour = result;
            //   this.learningPathMetaId = this.learningTour.learning_path_metas[0].id;
            // });
            console.log(this.survey.id);
            if (this.survey.type == 2) {
              this.learningTour.details.forEach(function (item, index) {
                if (item.ability_id == 6) {
                  that.item4 = item;
                  that.item4.surveyId = item.id;
                } else if (item.ability_id == 7) {
                  that.item1 = item;
                  that.item1.surveyId = item.id;
                } else if (item.ability_id == 8) {
                  that.item2 = item;
                  that.item2.surveyId = item.id;
                } else if (item.ability_id == 11) {
                  that.item5 = item;
                  that.item5.surveyId = item.id;
                } else if (item.ability_id == 10) {
                  that.item3 = item;
                  that.item3.surveyId = item.id;
                } else if (item.ability_id == 13) {
                  that.item7 = item;
                  that.item7.surveyId = item.id;
                } else if (item.ability_id == 12) {
                  that.item6 = item;
                  that.item6.surveyId = item.id;
                }

              });
            } else if (this.survey.type == 3) {
              this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningtour/' + this.learningTourId + '/surveyReport/2'
              }).subscribe(result2 => {
                this.preSurveyID = result2[0].survey_id;
                this.apiService.getDNAReport('' + this.preSurveyID + '').subscribe(result3 => {
                  this.learningTour.details.forEach(function (item, index) {
                    if (item.ability_id == 6) {
                      that.item4 = item;
                      that.item4.surveyId = item.id;
                    } else if (item.ability_id == 7) {
                      that.item1 = item;
                      that.item1.surveyId = item.id;
                    } else if (item.ability_id == 8) {
                      that.item2 = item;
                      that.item2.surveyId = item.id;
                    } else if (item.ability_id == 11) {
                      that.item5 = item;
                      that.item5.surveyId = item.id;
                    } else if (item.ability_id == 10) {
                      that.item3 = item;
                      that.item3.surveyId = item.id;
                    } else if (item.ability_id == 13) {
                      that.item7 = item;
                      that.item7.surveyId = item.id;
                    } else if (item.ability_id == 12) {
                      that.item6 = item;
                      that.item6.surveyId = item.id;
                    }
                  });
                  result3.details.forEach(function (item, index) {
                    if (item.ability_id == 6) {
                      that.item4.preLevel = item.level;
                      that.item4.preReport = item;
                    } else if (item.ability_id == 7) {
                      that.item1.preLevel = item.level;
                      that.item1.preReport = item;
                    } else if (item.ability_id == 8) {
                      that.item2.preLevel = item.level;
                      that.item2.preReport = item;
                    } else if (item.ability_id == 11) {
                      that.item5.preLevel = item.level;
                      that.item5.preReport = item;
                    } else if (item.ability_id == 10) {
                      that.item3.preLevel = item.level;
                      that.item3.preReport = item;
                    } else if (item.ability_id == 13) {
                      that.item7.preLevel = item.level;
                      that.item7.preReport = item;
                    } else if (item.ability_id == 12) {
                      that.item6.preLevel = item.level;
                      that.item6.preReport = item;
                    }
                  });
                });
              });
            } else {
            }
          });
        }
      });
    }
  }

  surveyInitCallBack() {
    //进入学地图时,各能力学习时长不计时
    if (this.survey.type == 1) {
      // localStorage.setItem("learningPathMetaId","0");
      // localStorage.setItem("learningPathMetaId-moduleId","0");
      this.apiService.ajax({
        'type': 'GET',
        'url': '/sr/exposeoutapi/setAbilitySession/0/0'
      }).subscribe(result => {
      });
    }
    let that = this;
    let temp = 1;
    this.sceneStartAndEnd = [];
    this.sceneNames = [];
    this.sceneDescription = [];
    let questionstmp = [];
    this.survey.scenes.forEach(function (item, index) {
      questionstmp = questionstmp.concat(item.questions);
      that.sceneStartAndEnd.push({
        index: index,
        start: temp,
        end: temp + item.questions.length - 1,
        popup: false
      });
      temp += item.questions.length;
      that.sceneNames.push(item.name);
      that.sceneDescription.push(item.description);
    });
    this.survey.questions = questionstmp;


    this.selectedQuestion = this.survey.questions[0];
    this.totalNumber = this.survey.questions.length;
    this.remindTime = this.survey.remind_time;
    this.totalTime = this.survey.total_time;
    this.currentNumber = this.survey.finished_number < this.survey.questions.length ? this.survey.finished_number + 1 : this.survey.questions.length;
    this.finishedNumber = this.survey.finished_number;
    this.sceneBtnDetailShow = false;

    if (this.survey.status == 0) {
      if (!this.restart) {
        this.step = 'begin';
      } else {
        this.onBegin(true);
      }
    } else {
      this.apiService.getDNAReport('' + this.survey.id + '').subscribe(result => {
        this.report = result.details[0];
        if (this.survey.type == 1) {
          this.step = 'report';
        } else {
          if (this.report && this.report.level > 0) {
            if (this.learningPathId == 'not') {
              this.step = 'tourReport';
              // $('body').css("height", "auto");
            } else if (this.learningTourId == 'not') {
              this.step = 'report';
            }
          } else {
            this.showFail(this);
          }
        }
      });
    }
  }

  onSceneBtnClick() {
    this.sceneBtnDetailShow = !this.sceneBtnDetailShow;
    if (this.sceneBtnDetailShow) {
      $('#sceneBtnDetail').show();
      $('#shade2').show();
    } else {
      $('#sceneBtnDetail').hide();
      $('#shade2').hide();
    }
  }

  sceneDetailClose() {
    this.sceneBtnDetailShow = !this.sceneBtnDetailShow;
    $('#sceneBtnDetail').hide();
    $('#shade2').hide();
  }

  onSceneTextBtnClick() {
    $('#shade').fadeOut(500);
    $('#scene_text').animate({
      'top': '-16rem'
    }, 500, function () {
      $('#scene_text').css({
        'top': '20rem'
      });
    });
  }

  onBegin(begin: boolean) {
    this.step = 'survey';
    this.sceneText = this.survey.scenes[0].description;
    this.sceneBtnDetailText = this.survey.scenes[0].description;
    this.sceneBtnDetail = this.survey.scenes[0].name;
    if (this.survey.type != 1) {
      this.SwitchBg();
    } else {
      this.SwitchDnaBg();
    }
    this.updateUsedtime();
  }

  SwitchBg() {
    var _this = this;
    if ($('#scene_text').length > 0) {
      document.documentElement.style.backgroundColor = '#3f4c84';
      $('#scene_text').animate({
        'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
      });
      $('#shade').fadeIn();
      document.getElementById('shade').ontouchmove = function (e) {
        e.preventDefault();
      };
      document.getElementById('scene_text').ontouchmove = function (e) {
        e.preventDefault();
      };
      document.getElementById('scene_text_btn').ontouchmove = function (e) {
        e.preventDefault();
      };
    } else {
      setTimeout(function () {
        _this.SwitchBg();
      }, 100);
    }
  }

  SwitchDnaBg() {
    var _this = this;
    if ($('#questionWrap').length > 0) {
      document.documentElement.style.backgroundColor = '#3f4c84';
    } else {
      setTimeout(function () {
        _this.SwitchDnaBg();
      }, 100);
    }
  }


  onRestart(restart: boolean) {
    this.restart = true;
    this.apiService.tickReset('0').subscribe(()=>{
      this.apiService.resetDNASurvey('' + this.survey.id + '').subscribe(data => {
        this.tickTimeData = null;//重置倒计时信息
        this.surveyInit();
        // if(this.commonService.getStorage('tourId')){
        //   this.step = 'begin';
        // }
      });
    });
    document.documentElement.style.backgroundColor = '#3f4c84';
  }

  onContinue(begin: boolean) {
    this.step = 'survey';
    document.documentElement.style.backgroundColor = '#3f4c84';

    if (this.survey.finished_number < this.survey.questions.length) {
      this.currentNumber = this.survey.finished_number + 1;
    } else {
      this.currentNumber = this.survey.questions.length;
    }
    if (this.survey.type != 1) {
      let index = this.getSceneByQuestion(this.currentNumber, this.sceneStartAndEnd);
      this.sceneText = this.sceneDescription[index];
      this.sceneBtnDetailText = this.sceneDescription[index];
      this.sceneBtnDetail = this.sceneNames[index];
    }
    if (this.survey.type != 1) {
      setTimeout(function () {
        $('#scene_text').animate({
          'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
        });
        $('#shade').fadeIn();
        document.getElementById('shade').ontouchmove = function (e) {
          e.preventDefault();
        };
        document.getElementById('scene_text').ontouchmove = function (e) {
          e.preventDefault();
        };
        document.getElementById('scene_text_btn').ontouchmove = function (e) {
          e.preventDefault();
        };
      }, 100);
    }


    this.selectedQuestion = this.survey.questions[this.currentNumber - 1];

    this.updateUsedtime();
  }

  setClickAble(event) {
    this.clickable = event;
  }

  onAnswer(optionId: number) {
    let that = this;
    if (this.clickable) {
      this.clickable = false;
    }

    this.apiService.answerQuestion('' + this.survey.id + '', this.selectedQuestion.id, optionId).subscribe(survey => {
      setTimeout(function () {
        if (that.currentNumber < that.survey.questions.length) {
          if (that.currentNumber > that.finishedNumber) {
            that.finishedNumber++;
          }
          that.currentNumber++;
          if (that.matchSceneChangeNumbers(that.currentNumber, that.sceneStartAndEnd) && that.survey.type != 1) {
            let object = that.matchSceneChangeNumbers(that.currentNumber, that.sceneStartAndEnd);
            $('#sceneBtn').text(that.sceneNames[object.index]);
            $('#scene_text p').text(that.sceneDescription[object.index]);
            $('#sceneBtnDetailText').html(that.sceneDescription[object.index]);
            if (!object.popup) {
              that.sceneStartAndEnd[object.index].popup = true;
              $('#scene_text').animate({
                'top': (document.documentElement.clientHeight - document.getElementById('scene_text').offsetHeight) / 2
              });
              $('#shade').fadeIn();
              document.getElementById('shade').ontouchmove = function (e) {
                e.preventDefault();
              };
              document.getElementById('scene_text').ontouchmove = function (e) {
                e.preventDefault();
              };
              document.getElementById('scene_text_btn').ontouchmove = function (e) {
                e.preventDefault();
              };
            }
          }
          that.selectedQuestion = that.survey.questions[that.currentNumber - 1];
        } else {
          $('#submit_circle').fadeIn(500);
        }
      }, 500);
    }, error => {
      this.clickable = false;
    });

  }

  onSlide(index: number) {
    if (index < 0 && this.currentNumber <= this.finishedNumber && this.currentNumber < this.survey.questions.length) {
      this.currentNumber++;
      this.selectedQuestion = this.survey.questions[this.currentNumber - 1];
    } else if (index > 0 && this.currentNumber > 1) {
      this.currentNumber--;
      this.selectedQuestion = this.survey.questions[this.currentNumber - 1];
    }
    if (this.survey.type != 1) {
      let index = this.getSceneByQuestion(this.currentNumber, this.sceneStartAndEnd);
      $('#scene_text p').text(this.sceneDescription[index]);
      $('#sceneBtnDetailText').html(this.sceneDescription[index]);
      $('#sceneBtn').text(this.sceneNames[index]);
    }
  }

  onTimeout() {
    $('#tip2').fadeIn(500);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    let that = this;
    if (this.survey.type == 1) {
      setTimeout(this.showFail, 2000, this);
    } else {
      if (this.finishedNumber == 0) {
        if (this.survey.type == 2) {
          setTimeout(function () {
            that.apiService.finishSurvey('' + that.survey.id + '','' + that.survey.type + '').subscribe(survey => {
              that.showFail(that);
            });
          }, 2000);
        } else if (this.survey.type == 3) {
          setTimeout(function () {
            that.apiService.finishSurvey('' + that.survey.id + '','' + that.survey.type + '').subscribe(survey => {
              that.showPostSurveyTip();
            });
          }, 2000);
        }
        /*setTimeout(this.showFail,2000, this);*/
      } else {
        if (this.survey.type == 2) {
          setTimeout(function () {
            that.apiService.finishSurvey('' + that.survey.id + '','' + that.survey.type + '').subscribe(survey => {
              that.step = 'report';
            });
          }, 2000);
        } else if (this.survey.type == 3 && this.learningPathId !== '0') {
          setTimeout(function () {
            that.apiService.finishSurvey('' + that.survey.id + '','' + that.survey.type + '').subscribe(survey => {
              that.showPostSurveyTip();
            });
          }, 2000);
        }
      }
    }
  }

  showFail(targetObj) {
    $('#tip2').fadeOut(500);
    targetObj.step = 'fail';
    if (this.survey && this.survey.type == 1 ) {
      targetObj.apiService.resetSurvey('' + targetObj.survey.id + '').subscribe(data => {
      });
    }
  }

  onTimeReminder() {
    $('#tip1').fadeIn(500);

    setTimeout(function () {
      $('#tip1').fadeOut(500);
    }, 2000);
  }

  onSubmit() {
    if (this.learningTourId == 'not') {
      this.apiService.finishSurvey('' + this.survey.id + '','' + this.survey.type + '').subscribe(survey => {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        if (this.survey.type == 3 && this.learningPathId !== '0') {
          this.showPostSurveyTip();
        } else {
          this.step = 'report';
        }
      });
    } else if (this.learningPathId == 'not') {
      this.apiService.finishSurvey('' + this.survey.id + '','' + this.survey.type + '').subscribe(result => {
        if(localStorage.getItem("source_env") == "LMS_SCORM"){
          this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',100,"data");
          this.commonService.sendDataMessage('type','LMS_LEARN_COMPLETED',true,"data");
        }
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        // post survey
        if (this.survey.type == 3 && this.learningPathId !== '0') {
          // this.showPostSurveyTip();
          this.step = 'tourReport';
          // $('body').css("height", "auto");
          this.surveyInit();
          document.documentElement.style.backgroundColor = 'white';

        } else {
          this.step = 'tourReport';
          // $('body').css("height", "auto");
          this.surveyInit();
          document.documentElement.style.backgroundColor = 'white';
        }
      });
    }
  }

  linkToTourReport(item) {
    this.tourSingleReport = item;
    this.step = 'report';

  }

  directToGraduation(firstEntry) {
    let link = ['graduation', this.learningPathId, 0, firstEntry ? 1 : 0];
    this.router.navigate(link);
  }

  showPostSurveyTip() {
    if (this.learningTourId == 'not') {
      this.apiService.getGraduationByLearningPathId('' + this.learningPathId + '', '' + '0' + '').subscribe(graduation => {
        this.graduation = graduation;
        if (this.graduation.postSurveyLevel == '0') {
          this.showFail(this);
        } else {
          /*let link = ['post-ability-test-tip', this.graduation.postSurveyLevel,this.learningPathId];
          this.router.navigate(link);*/
          this.step = 'report';
        }
      });
    } else {
      this.apiService.ajax({
        'type': 'get',
        'url': '/api/learningtour/' + this.learningTourId + '/graduation/0',
        'data': {}
      }).subscribe(result => {
        if (result.postSurveyReports[0].coaching == '0') {
          this.showFail(this);
        } else {
          /*let link = ['post-ability-test-tip', result.postSurveyReports[0].coaching,0];
          this.router.navigate(link);*/
          this.step = 'tourReport';
          // $('body').css("height", "auto");
          this.surveyInit();
          document.documentElement.style.backgroundColor = 'white';
        }
      });
    }
  }

  async updateUsedtime() {
    let that = this;
    let survey = that.survey;
    console.log('survey', survey);
    let apiService = that.apiService;
    //获取tick
    console.log("tickTimeData", that.tickTimeData);
    if(!that.tickTimeData || !that.tickTimeData.id){
      that.tickTimeData = await that.getTickInit();
      console.log("tickTimeData", that.tickTimeData);
      if(that.tickTimeData.usedTime >= that.survey.total_time){
        return;//如果已经超时，不走倒计时接口了
      }
    }
    that.intervalId = setInterval(function () {
      console.log('开始调用倒计时接口');
      // var usedTime = survey.used_time;
      apiService.tickUpdateSurveyTime('' + that.tickTimeData.tickId + '').subscribe(data => {
        console.log('倒计时调用成功：',data);
      });
    }, 1000);
  }

  getTickInit(){
    return this.apiService.tickInit('0').toPromise();
  }

  exit() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.learningPathId == 'not') {
      let projectId = localStorage.getItem("projectId")
      let link = ['learning-map'];
      if(projectId){
        link = ['learning-project', projectId]
      }
      this.router.navigate(link);
    } else {
      this.apiService.ajax({
        'type': 'get',
        'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
      }).subscribe(result => {
        // if(this.projectId && this.projectId.trim() != ''){
        //   localStorage.removeItem("projectmsg")
        //   let link = ['learning-project-path', result.data];
        //   this.router.navigate(link,{
        //     queryParams:{
        //       projectId: this.projectId
        //     }
        //   });
        // }else{
          let link = ['learning-path', result.data];
          this.router.navigate(link);
        // }

      });
    }
  }

  close() {
    $('#shade').fadeIn();
    $('#tip3').fadeIn();
    document.getElementById('tip3').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('tip3Text').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('quitBtn').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('continueBtn').ontouchmove = function (e) {
      e.preventDefault();
    };
  }

  goBackSurvey() {
    this.step = 'tourReport';
    // $('body').css("height", "auto");
  }

  continue() {
    $('#shade').fadeOut();
    $('#tip3').fadeOut();
  }

  matchSceneChangeNumbers(num: number, object: any) {
    for (let i = 0; i < object.length; i++) {
      if (object[i].start == num) {
        return object[i];
      } else {
        continue;
      }
    }
    return false;
  }

  getSceneByQuestion(num: number, object: any) {
    for (let i = 0; i < object.length; i++) {
      if (num >= object[i].start && num <= object[i].end) {
        return object[i].index;
      }
    }
  }

  // getMockSurvery() {
  //
  //     this.survey = {
  //         id: 1,
  //         name: "领导力DNA测验",
  //         description: "欢迎进入领导力DNA测验，本测试共有40道题目，请根据自己的第一反应作答，计时30分钟。作答完成后你将获得个性化的领导力DNA解读报告，但是只有全部完成才能获得，越是真实的反应，结果越准确哦！",
  //         type: 2,
  //         total_time: 1800,
  //         remind_time: 600,
  //         progress: 0,
  //         status: 0,
  //         start_time: "2017-11-20 00:00:00",
  //         scenes:[{
  //             name: "挑战场景1",
  //             description: "为完成一个新项目，你的下属将第一次独自带领一个跨部门项目团队，他对此不是很有经验和信心，为帮助他更好地胜任这个角色，你决定采取以下行动，请对每项行动的有效程度做出评估。",
  //             questions: [
  //                 {id: 1, description : "一旦实现一个目标，我会再设定一个难度更大的目标。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 2, description: "你更喜欢独处。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 3, description: "你喜欢和同事保持良好关系。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 4, description: "你喜欢成为人群中的焦点。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 5, description: "你喜欢评价别人的工作。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]}
  //             ]
  //         },{
  //             name: "挑战场景2",
  //             description: "最近一个月，你的一位下属在工作中表现不似以往那样积极主动，业绩也呈现下滑趋势，为了帮助他提升工作表现，你决定采取以下行动，请对每项行动的有效程度做出评估。",
  //             questions: [
  //                 {id: 6, description : "6一旦实现一个目标，我会再设定一个难度更大的目标。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 7, description: "7你更喜欢独处。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 8, description: "8你喜欢和同事保持良好关系。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 9, description: "9你喜欢成为人群中的焦点。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 10, description: "10你喜欢评价别人的工作。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 11, description: "11你喜欢评价别人的工作。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //             ]
  //         },{
  //             name: "挑战场景3",
  //             description: "3最近一个月，你的一位下属在工作中表现不似以往那样积极主动，业绩也呈现下滑趋势，为了帮助他提升工作表现，你决定采取以下行动，请对每项行动的有效程度做出评估。",
  //             questions: [
  //                 {id: 12, description : "12一旦实现一个目标，我会再设定一个难度更大的目标。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 13, description: "13你更喜欢独处。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 14, description: "14你喜欢和同事保持良好关系。", options: [{"value": 1, "description": "不符", "selected": true},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 15, description: "15你喜欢成为人群中的焦点。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]},
  //                 {id: 16, description: "16你喜欢评价别人的工作。", options: [{"value": 1, "description": "不符", "selected": false},{"value": 2, "description": "较不符", "selected": false},{"value": 3, "description": "不确定", "selected": false},{"value": 4, "description": "较符合", "selected": false},{"value": 5, "description": "符合", "selected": false}]}
  //             ]
  //         }],
  //         finished_number: 0,
  //         used_time: 0
  //     };
  //
  //     this.step = "survey";
  //     let questionstmp = [];
  //     let temp = 1;
  //     this.sceneStartAndEnd = [];
  //     this.sceneNames = [];
  //     this.sceneDescription = [];
  //     let that = this;
  //     let scenensNumber = this.survey.scenes.length;
  //     this.survey.scenes.forEach(function (item,index) {
  //         questionstmp = questionstmp.concat(item.questions);
  //         that.sceneStartAndEnd.push({
  //             index:index,
  //             start: temp,
  //             end: temp+item.questions.length-1,
  //             popup:false
  //         });
  //         temp += item.questions.length;
  //         that.sceneNames.push(item.name);
  //         that.sceneDescription.push(item.description);
  //     });
  //     console.log(this.sceneStartAndEnd);
  //     console.log(this.sceneNames);
  //     console.log(this.sceneDescription);
  //     this.survey.questions = questionstmp;
  //     this.selectedQuestion = this.survey.questions[0];
  //     this.totalNumber = this.survey.questions.length;
  //
  //
  //     this.finishedNumber = this.survey.finished_number;
  //     /*this.currentNumber = this.survey.finished_number < this.survey.questions.length ? this.survey.finished_number + 1 : this.survey.questions.length;*/
  //     this.currentNumber = 1;
  // }
}



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.ts